import {
  Button,
  Heading,
  Text,
  Flex,
  VStack,
  useColorModeValue,
  Container,
} from "@chakra-ui/react";
import Router from "next/router";
import { NextSeo } from "next-seo";
import { FiHome } from "react-icons/fi";

const Page404 = () => {
  const bgGradient = useColorModeValue(
    "linear(to-b, neutral.50, white)",
    "linear(to-b, neutral.900, neutral.800)"
  );
  const subtitleColor = useColorModeValue("neutral.600", "neutral.400");
  const codeColor = useColorModeValue("neutral.300", "neutral.600");

  return (
    <>
      <NextSeo title="Page Not Found" description="404 - Page not found" />
      <Flex
        minHeight="80vh"
        direction="column"
        justifyContent="center"
        alignItems="center"
        bgGradient={bgGradient}
      >
        <Container maxW="lg">
          <VStack spacing={6} textAlign="center">
            {/* Large 404 text in background */}
            <Text
              fontSize={{ base: "8rem", md: "12rem" }}
              fontWeight={800}
              color={codeColor}
              lineHeight={1}
              letterSpacing="tight"
              userSelect="none"
            >
              404
            </Text>

            {/* Content */}
            <VStack spacing={3}>
              <Heading
                fontSize={{ base: "2xl", md: "3xl" }}
                fontWeight={700}
                letterSpacing="tight"
              >
                Page not found
              </Heading>
              <Text
                fontSize={{ base: "md", md: "lg" }}
                color={subtitleColor}
                maxW="md"
              >
                Sorry, the page you&apos;re looking for doesn&apos;t exist or
                has been moved.
              </Text>
            </VStack>

            {/* Action Button */}
            <Button
              leftIcon={<FiHome />}
              bg="brand.500"
              color="white"
              size="lg"
              px={8}
              borderRadius="xl"
              fontWeight={600}
              _hover={{
                bg: "brand.600",
                transform: "translateY(-2px)",
                shadow: "lg",
              }}
              _active={{
                bg: "brand.600",
                transform: "translateY(0)",
              }}
              transition="all 0.2s"
              onClick={() => Router.push("/")}
            >
              Back to Home
            </Button>
          </VStack>
        </Container>
      </Flex>
    </>
  );
};

export default Page404;
